import { Event } from "../model/impl/Event";
import { EventType } from "../enum/EventType";
import { Player } from "../model/impl/Player";
import { Protection } from "../model/impl/Protection";
import { Weapon } from "../model/impl/Weapon";
import { Position } from "../model/impl/Position";


export class Converter {
    public static convertToEvent(data: any): Event | null {
        let type:string="";
        let durationMillis:number=0;
        let convertedType: EventType;
        let timestamp:string="";
        let internalMissionId:string=data.internalMissionId;

        let converted_players : Player[]=[];

        if(data.type){
            type=data.type;
        }

        if(data.eventType){
            type=data.eventType;
        }

        if(data.timestamp){
            timestamp=data.timestamp;
        }

        if(data.eventTimestamp){
            timestamp=data.eventTimestamp;
        }

        let counter : number=0;

        while(counter<data.players.length){
            let player:Player=new Player(data.players[counter].playerId, data.players[counter].hits, data.players[counter].points, data.players[counter].killed);
            converted_players.push(player);
            counter++;
        }

        switch(type){
            case "hitEvent":
                convertedType=EventType.HIT_EVENT;
                durationMillis=2000;
                break;
            
            case "missionStatusEvent":
                convertedType=EventType.MISSION_STATUS_EVENT;

                durationMillis=3000;
                break;

            case "kitStatusEvent":
                convertedType=EventType.KIT_STATUS_EVENT;
                durationMillis=500;
                break;

            case "reviveEvent":
                convertedType=EventType.REVIVE_EVENT;

                durationMillis=3000;
                break;
            
            default:
                return null;
        }

        let ev:Event= new Event(timestamp,convertedType,internalMissionId,durationMillis);
        ev.players=converted_players;

        switch(convertedType){
            case EventType.HIT_EVENT:
                ev.kitId=data.data.kitId;
                ev.sourceId=data.data.sourceId;
                ev.hitZone=data.data.hitZone;
                ev.ammoType=data.data.ammoType;
                ev.isKilled=data.data.isKilled;

                ev.sourcePath="https://i.pinimg.com/originals/e9/5a/9f/e95a9fb43f32e8766a97aec1f55829e4.gif";
                break;

            case EventType.KIT_STATUS_EVENT:
                let protections_counter:number=0;
                let weapons_counter:number=0;
                let weapons:Weapon[]=[];
                let protections : Protection[] = [];
                let position : Position = new Position(data.data.position.latitude, data.data.position.longitude, data.data.position.altitude);

                while(protections_counter<data.data.protections.length){
                    protections[protections_counter]=new Protection(data.data.protections[protections_counter].protectionZone, data.data.protections[protections_counter].protectionType, data.data.protections[protections_counter].protectionLevel);
                    protections_counter++;
                }

                while(weapons_counter<data.data.weapons.length){
                    weapons[weapons_counter]=new Weapon(data.data.weapons[weapons_counter].weaponId, data.data.weapons[weapons_counter].ammoType);
                    weapons_counter++;
                }
                
                ev.kitId=data.data.kitId;
                ev.lacsMissionId=data.data.missionId;
                ev.kitStatus=data.data.kitStatus;
                ev.hits=data.data.hits;

                ev.protections=protections;
                ev.weapons=weapons;
                ev.position=position;

                ev.sourcePath="https://data.textstudio.com/output/sample/animated/5/7/3/5/information-3-5375.gif";

                break;

            case EventType.MISSION_STATUS_EVENT:
                ev.lacsMissionId=data.data.missionId;
                ev.missionStatus=data.data.missionStatus;
                ev.sourcePath ='https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif';
                break;

            case EventType.REVIVE_EVENT:
                ev.kitId=data.data.kitId;
                ev.sourceId=data.data.sourceId;
                ev.sourcePath="https://media.tenor.com/KOjqcTw08-wAAAAM/revives-revive.gif";
                break;
        }

        return ev;
    }
}